// extracted by mini-css-extract-plugin
module.exports = {"headline":"styles_headline__PvbJM","label":"styles_label__6dPRS","caption":"styles_caption__boITU","description":"styles_description__l7iEz","content":"styles_content__UyDZi"};